import { SET_SELECTED_PRODUCT } from './action';

const initialState = {
  selected_product: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case SET_SELECTED_PRODUCT:
    return {
      ...state,
      selected_product: payload,
    };
  default:
    return { ...state };
  }
};
